import { useEffect, useState } from "react";
import { store } from "../../lib/stores";
import { AuthActions } from "../../lib/stores/auth/slices";
import { FlowsActions } from "../../lib/fetchers/flows";
import { PlanActions } from "../../lib/fetchers/plans";
import { ContentEntityTypesActions } from "../../lib/fetchers/contentEntityTypes";
import { ContentEntitiesActions } from "@lib/fetchers/allowedContentEntities";

export const loadAuthorizedData = () => {
  return Promise.all([
    // store.dispatch(AuthActions.setMyExpoPushTokenAsync()),
    ContentEntityTypesActions.getContentEntityTypeLookupsAsync(),
    ContentEntitiesActions.getAllowedContentEntitiesAsync(),
    FlowsActions.getReaderFlowAsync(),
    PlanActions.getMyPlansAsync(),
    store.dispatch(AuthActions.getMyInfoAsync()),
    store.dispatch(AuthActions.getLinkedAccountsAsync()),
    async () => {},
  ]);
};

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = useState(false);

  // Load any resources or data that we need prior to rendering the app
  useEffect(() => {
    async function dataPreparation() {
      await store.dispatch(AuthActions.loadAuthAsync());
    }

    async function loadResourcesAndDataAsync() {
      try {
        // await Promise.all([loadImages(), loadFonts()]);

        await dataPreparation();
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        // SplashScreen?.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
